/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { toISTDate } from '@Apis/constants';
import { CheckOutlined, EditFilled } from '@ant-design/icons';
import { DatePicker, Popover } from 'antd';
import './style.scss';
import dayjs from 'dayjs';

const ViewCustomFieldLine = ({
  wrapperClass, labelClass, valueClass, customFields, isHorizontal, cfId, quickUpdateApi, entityLineName, lineId, isEditable, activityLogUpdater, entityId, cfV2Doc, 
}) => {
  const [editingId, setEditingId] = useState(null);
  const [fieldValue, setFieldValue] = useState('');
  const [dateValue, setDateValue] = useState(null);
  const [tempCustomFields, setTempCustomFields] = useState([]);
 
  useEffect(()=>{

    if(cfV2Doc?.data?.success){

      const mergedArrayForLineCf = cfV2Doc?.data?.document_line_custom_fields?.map((newField) => {

        const oldField = customFields?.find((old) => (old?.cf_id===newField?.cf_id));

        return {
          ...newField,
          field_value: oldField?.field_value || newField?.field_value,
          is_editable_on_update: oldField?.is_editable_on_update || newField?.is_editable_on_update,
          is_editable_while_carrying_forward: oldField?.is_editable_while_carrying_forward || newField?.is_editable_while_carrying_forward,
          visible: oldField?.visible || false,
        }
      })?.filter((item) => (item?.visible));

      setTempCustomFields(mergedArrayForLineCf);

    } else{
      setTempCustomFields(customFields);
    }
  }, [cfV2Doc])

  const handleIconClick = (id, value, type) => {
    setEditingId(id);
    if (type === 'DATE') {
      setDateValue(value ? dayjs(value) : null);
    } else {
      setFieldValue(value);
    }
  };

  const handleInputChange = (e) => {
    setFieldValue(e.target.value);
  };

  const handleDateChange = (date) => {
    setDateValue(date || null);
  };

  const saveChanges = (id, type) => {
    const payload = {
      [entityLineName]: lineId,
      ...entityId,
      line_custom_fields: [{
        cf_id: id,
        field_value: type === 'DATE' ? (dateValue ? dateValue.format('YYYY-MM-DD') : null) : fieldValue,
      }],
    };
    quickUpdateApi(payload, () => activityLogUpdater(), () => {
      setFieldValue(null);
      setDateValue(null);
    });
    setEditingId(null);
  };

  return (
    <div
      className="main_wrapper_for_line_level_fields"
    >
      <div className='ant-row'>
      {
        tempCustomFields?.filter((item) => (item.cf_id === cfId && (item?.field_value || isEditable) && (item?.field_type !== 'ATTACHMENT')))?.map((item) => (
          <div
            className={`${wrapperClass} custom-field-item`}
            key={item.cf_id}
          >
            {!['CHECKBOX'].includes(item?.field_type) && (
              editingId === item.cf_id ? (
                <div className="update_custom_fields_line_level">
                  {item.field_type === 'DATE' ? (
                    <DatePicker
                      value={dateValue}
                      onChange={handleDateChange}
                      className={valueClass}
                      format="DD/MM/YYYY"
                      // allowClear={false}
                      disabled={!item?.is_editable_on_update}
                    />
                  ) : (
                    <input
                      value={fieldValue}
                      onChange={handleInputChange}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          saveChanges(item.cf_id, item.field_type);
                        }
                      }}
                      className={valueClass}
                      style={{
                        border: '2px solid rgb(223, 237, 248)',
                      }}
                      disabled={!item?.is_editable_on_update}
                    />
                  )}
                  &nbsp;
                  <CheckOutlined
                    style={{ color: '#1890ff', cursor: 'pointer' }}
                    onClick={() => saveChanges(item.cf_id, item.field_type)}
                  />
                </div>
              ) : (
                <div className="view_and_edit_line_level_cf">
                  {item.field_type === 'DATE' ? (
                    <H3Text text={(dateValue || item.field_value) ? toISTDate(dateValue || item.field_value).format('DD MMM, YYYY') : null} className={valueClass} />
                  ) : (
                    <H3Text text={fieldValue || item.field_value} className={valueClass} />
                  )}
                  &nbsp;
                  {isEditable && item?.is_editable_on_update &&  (
                    <EditFilled
                      className="edit-icon"
                      onClick={() => handleIconClick(item.cf_id, item.field_value, item.field_type)}
                      disabled={!item?.is_editable_on_update}
                    />
                  )}
                </div>
              )
            )}
          </div>
        ))
      }
      {
        tempCustomFields?.filter((item) => (item.cf_id === cfId && (item?.field_value || isEditable) && (item?.field_type === 'ATTACHMENT')))?.map((item) => (
          <div
            className={`${wrapperClass} custom-field-item`}
            key={item.cf_id}
          >
            {item?.field_type === "ATTACHMENT" &&
                  item?.field_value?.length > 0 && (
                    <Fragment>
                      <div style={{ display: "block" }} className={valueClass}>
                        {editingId === item.cf_id ? (
                          <input
                            type="file"
                            onChange={(e) =>
                              handleFileChangeEWayBill(
                                item.cf_id,
                                item.field_type,
                                e
                              )
                            }
                            className="document-custom-input"
                            disabled={!item?.is_editable_on_update}
                          />
                        ) : (
                          <div className="custom_field_edit_and_view_attachment">
                            <Popover
                              content={
                                <div>
                                  {item?.field_value?.map((file) => (
                                    <div
                                      key={file?.name}
                                      onClick={() => window.open(file?.url)}
                                    >
                                      <a>
                                        {file?.name?.length > 30
                                          ? `${file?.name.substring(0, 30)}...`
                                          : file?.name}
                                      </a>
                                      <br />
                                    </div>
                                  ))}
                                </div>
                              }
                              title="Attachments"
                              trigger="click"
                            >
                              <div
                                style={{
                                  cursor: "pointer",
                                  background: "#2d7cf7",
                                  padding: "0.5px 4px",
                                  borderRadius: "3px",
                                  color: "white",
                                }}
                              >
                                Attachments
                              </div>
                            </Popover>
                          </div>
                        )}
                      </div>
                    </Fragment>
                  )}
          </div>
         ))
      }
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

ViewCustomFieldLine.propTypes = {
  customFields: PropTypes.any,
  wrapperClass: PropTypes.string,
  labelClass: PropTypes.string,
  valueClass: PropTypes.string,
  isHorizontal: PropTypes.bool,
  cfId: PropTypes.number,
  quickUpdateApi: PropTypes.func,
  entityLineName: PropTypes.string,
  lineId: PropTypes.number,
  isEditable: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewCustomFieldLine));
